import dividerStyle from "./divider.module.scss";
import icn_drawer_down from "assets/images/icons/icn_drawer_down.svg";

import { Box } from "@mui/material";

const Divider = () => {
  return (
    <Box className={dividerStyle['divider']}>
      <img className={dividerStyle['img']} src={icn_drawer_down} alt="icn_drawer_down" />
    </Box>
  );
}

export default Divider;